import { useParams, useSearchParams } from "react-router-dom";
import { UnifiedProfilePage } from "@b2b/ui-components/features/ProfileSettings";
import { useAuth } from "../auth/Authprovider";
import { BizcoverIndiaFigmaHeader } from "../components/marketing/BizcoverIndiaFigmaHeader";

const ProfileSettingsPage = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const userId = id || searchParams.get("userId") || undefined;
  const editMode = searchParams.get("edit") === "true";
  const { userRole, profileCompletionPercentage, refetchUserStatus } = useAuth();

  return (
    <div className="min-h-screen bg-[#f4f6f8] flex flex-col">
      <BizcoverIndiaFigmaHeader />
      <main className="flex-1">
        <UnifiedProfilePage
          userId={userId}
          initialEditMode={editMode}
          profileCompletionPercentage={userRole === "seller" ? profileCompletionPercentage : undefined}
          userRole={userRole}
          buyerBusinessEmailSettingsField
          onProfileUpdate={() => refetchUserStatus()}
        />
      </main>
    </div>
  );
};

export default ProfileSettingsPage;
